<template>
  <div
    style="height: 200px"
    :class="
      currentRouteName == 'Home'
        ? 'bg_index'
        : currentRouteName == 'SignIn'
        ? 'bg_login'
        : currentRouteName == 'Reserve'
        ? 'bg_service'
        : currentRouteName == 'ReserveDone'
        ? 'bg_reservation'
        : currentRouteName == 'MyNumber'
        ? 'bg_reservation'
        : 'bg_index'
    "
  >
    <nav class="navbar" style="top: 40px">
      <div class="container row">
        <div class="col-2">
          <a
            class="navbar-brand logo no-hover"
            data-bs-toggle="offcanvas"
            href="#side_menu"
          >
            <img src="@/assets/side_menu.png" style="margin-left: 30px" />
          </a>
        </div>
        <div class="col-8">
          <a class="navbar-brand logo" href="/">
            <img src="@/assets/logo.png" alt="" />
          </a>
        </div>
        <div class="col-1"></div>
      </div>
    </nav>
    <div
      class="offcanvas offcanvas-start"
      tabindex="-1"
      id="side_menu"
      aria-labelledby="offcanvasExampleLabel"
      style="max-width: 70%; background-color: black"
    >
      <div
        class="offcanvas-header"
        style="display: block !important; margin-top: 18px"
      >
        <img src="@/assets/logo_mix.png" />
      </div>
      <div class="offcanvas-body" style="text-align: left; margin-left: 36px">
        <div class="mt-3" v-if="!data.isSignIn">
          <ul class="" aria-labelledby="">
            <li><a class="menu_item" href="/">首頁｜Home</a></li>
            <li>
              <a
                class="menu_item"
                href="https://www.facebook.com/gutsquickcut666"
                target="_blank"
                >Facebook</a
              >
            </li>
            <li>
              <a
                class="menu_item"
                href="https://www.instagram.com/guts_barber_1987/"
                target="_blank"
                >Instagram
              </a>
            </li>
          </ul>
        </div>
        <div class="mt-3" v-if="data.isSignIn">
          <ul class="" aria-labelledby="">
            <li><a class="menu_item" href="/">首頁｜Home</a></li>
            <li>
              <a
                class="menu_item"
                data-bs-toggle="offcanvas"
                href="#side_menu"
                @click="pushPage('/myNumber')"
                >我的號碼｜Number</a
              >
            </li>
            <li>
              <a
                class="menu_item"
                data-bs-toggle="offcanvas"
                href="#side_menu"
                @click="pushPage('/member')"
                >我的帳戶｜Personal</a
              >
            </li>
            <li v-if="data.permStatus">
              <a
                class="menu_item"
                data-bs-toggle="offcanvas"
                href="#side_menu"
                @click="pushPage('/permBooking')"
                >預約燙髮｜Booking</a
              >
            </li>
            <li>
              <a
                class="menu_item"
                href="https://www.facebook.com/gutsquickcut666"
                target="_blank"
                >Facebook</a
              >
            </li>
            <li>
              <a
                class="menu_item"
                href="https://www.instagram.com/guts_barber_1987/"
                target="_blank"
                >Instagram
              </a>
            </li>
          </ul>
          <ul class="" aria-labelledby="" style="margin-top: 100px">
            <li>
              <a class="menu_item" href="#" @click="logout()"
                >登出 ｜ Sign out</a
              >
            </li>
          </ul>
        </div>
      </div>
      <p class="version-text">v {{ data.version }}</p>
    </div>
  </div>
</template>

<script>
import { reactive, computed } from "@vue/runtime-core";
import { useStore } from "vuex";
import axios from "axios";
import { getPermBookingByMemberPhone } from "@/services/permBookingService";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  setup() {
    const data = reactive({
      isSignIn: false,
      permStatus: true,
      version: process.env.VUE_APP_VERSION,
    });
    const store = useStore();
    const states = reactive({
      username: computed(() => store.state.auth.user.username),
      isAuthenticated: computed(() => store.getters["auth/isAuthenticated"]),
      token: computed(() => store.state.auth.token),
    });

    // get token to localStorage
    const token = JSON.parse(localStorage.getItem("token"));

    data.isSignIn = states.token != null || token != null;

    if (data.isSignIn) {
      const config = {
        headers: { Authorization: `Bearer ${states.token}` },
      };
      axios
        .get(`${process.env.VUE_APP_URL}/member/detail`, config)
        .then(async (res) => {
          const phone = res.data?.data?.phone;
          try {
            await getPermBookingByMemberPhone(phone);
            data.permStatus = true;
          } catch (e) {
            data.permStatus = e?.response?.status !== 403;
          }
        })
        .catch((e) => {
          console.log(e);
          data.permStatus = e?.response?.status !== 403;
        });
    }

    return {
      data,
      states,
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    logout() {
      // 呼叫 Vuex 的 logout action 來進行登出
      this.$store.dispatch("auth/logout");
      // clear token from localStorage
      localStorage.removeItem("token");
      // 導向回首頁
      window.location.reload();
    },
    pushPage(page) {
      this.$router.push({ path: page });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.footer_title {
  font-family: "IBM Plex Mono";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #eeae08;
}
.footer_address {
  margin-top: 8px;
  font-family: "IBM Plex Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
}
.footer_time {
  font-family: "IBM Plex Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
}
.menu_item {
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 25px;
  color: #ffffff;
  text-decoration: none;
}
ul li {
  display: block;
  margin: 20px 0px 20px 0px;
}
.bg_index {
  background-image: url("@/assets/bg_index.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bg_login {
  background-image: url("@/assets/bg_login.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bg_service {
  background-image: url("@/assets/bg_service.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bg_reservation {
  background-image: url("@/assets/bg_reservation.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.version-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  color: #ffffff;
}

</style>
